
import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { IframeCommunicationService } from 'src/app/shared/services/iframe-communication/iframe-communication.service';

export type BUTTONCARDBUTTON = { text: string, className: string, onClick: string } | string

@Component({
  selector: 'app-button-card',
  imports: [NgClass],
  standalone: true,
  templateUrl: './button-card.component.html',
  styleUrl: './button-card.component.scss'
})
export class ButtonCardComponent {
  private _disabled = false;
  public readonly buttons = input<BUTTONCARDBUTTON[]>([]);
  public readonly isLast = input.required<boolean>();
  constructor(private iframeService: IframeCommunicationService) { }

  public getLabel(b: BUTTONCARDBUTTON) {
    if (typeof b === 'string') {
      return b;
    } else {
      return b.text;
    }
  }

  public get disabled() {
    if (!this.isLast()) { return true; }
    return this._disabled;
  }

  public getClassName(b: BUTTONCARDBUTTON) {
    if (typeof b === 'string') {
      return "";
    }
    // css is the legacy property name from the Blockly generator
    return b.className || ((b as unknown as { css?: string }).css ?? "");
  }

  public onClick(b: BUTTONCARDBUTTON, e: unknown) {
    this._disabled = true;
    const button = (e as PointerEvent).target as HTMLElement;
    button.classList.add("active");
    window.buttonCardClickEvent = e;
    console.log(e);
    if (typeof b === 'string') {
      this.iframeService.RAGAI.EVENTS.trigger("RAGAI.BUTTON.CLICK", { text: b });
      this.iframeService.RAGAI.MSG.userMessage(b);
    }
    else {
      eval('(' + b.onClick + ')()');
    }
  }
}
